export default __webpack_public_path__ + "static/media/git.c60b7e5a.svg";